<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M1.333 12V4h13.334v8h-1.333v-1.333h-2.667V12H9.334V5.333H2.667V12H1.334Zm9.334-5.333h2.667V5.333h-2.667v1.334Zm0 2.666h2.667V8h-2.667v1.333Z"
        />
    </svg>
</template>

<script setup lang="ts">
type DeskIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<DeskIconProps>();
</script>
